import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Col, Form, Input, Row, Spin, theme } from "antd";
import { observer } from "mobx-react";
import { useCallback, useMemo } from "react";
import { RealCommerceError } from "../../../../../exceptions/realCommerceError.js";
import { useStores } from "../../../../../store/stores.js";
import { __ } from "../../../../../utils/i18n.js";
import { useAccountV2ErrorHandling } from "../../../hooks/useAccountV2ErrorHandling.js";
const PersonalDataFormCard = observer(()=>{
    const { token } = theme.useToken();
    const { accountV2Store } = useStores();
    const { session } = accountV2Store;
    const handleRealCommerceError = useAccountV2ErrorHandling();
    const initialValues = useMemo(()=>({
            email: session?.user?.email ?? "",
            firstName: session?.user?.firstName ?? "",
            lastName: session?.user?.lastName ?? ""
        }), [
        session?.user?.email,
        session?.user?.firstName,
        session?.user?.lastName
    ]);
    const [form] = Form.useForm();
    const onFinish = useCallback(async ({ email, ...rest })=>{
        if (!session) {
            return;
        }
        try {
            await session.updateDetails({
                ...rest,
                unconfirmedEmail: email
            });
        } catch (e) {
            if (e instanceof RealCommerceError) {
                handleRealCommerceError(e);
            }
        }
    }, [
        session
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-details-card",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-details-card__head",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "rc-account-v2-details-card__heading",
                        style: {
                            color: token.colorTextHeading
                        },
                        children: __("Your personal data")
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "rc-account-v2-details-card__intro",
                        style: {
                            color: token.colorTextSecondary
                        },
                        children: __("These details belong to your account and apply to all subscriptions within it.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-details-card__body",
                children: /*#__PURE__*/ _jsx(Spin, {
                    spinning: !!session?.isBusy,
                    children: /*#__PURE__*/ _jsxs(Form, {
                        form: form,
                        layout: "vertical",
                        onFinish: onFinish,
                        initialValues: initialValues,
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                label: __("Email"),
                                name: "email",
                                rules: [
                                    {
                                        type: "email",
                                        required: true,
                                        message: __("Please enter a valid email address.")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Input, {})
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                gutter: 16,
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 24,
                                        md: 12,
                                        children: /*#__PURE__*/ _jsx(Form.Item, {
                                            label: __("First name"),
                                            name: "firstName",
                                            rules: [
                                                {
                                                    required: true,
                                                    message: __("Please enter your first name.")
                                                }
                                            ],
                                            children: /*#__PURE__*/ _jsx(Input, {})
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 24,
                                        md: 12,
                                        children: /*#__PURE__*/ _jsx(Form.Item, {
                                            label: __("Last name"),
                                            name: "lastName",
                                            rules: [
                                                {
                                                    required: true,
                                                    message: __("Please enter your last name.")
                                                }
                                            ],
                                            children: /*#__PURE__*/ _jsx(Input, {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                style: {
                                    textAlign: "right",
                                    marginBottom: 0
                                },
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "primary",
                                    htmlType: "submit",
                                    loading: !!session?.isBusy,
                                    children: __("Save changes")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
});
export { PersonalDataFormCard };
